import { createEntityActionNames, createEntityActions } from "store/entities/actions";
import { IMailbox } from "store/entities/mailboxes/interfaces";
import { ActionsUnion, createAction } from "store/helper";

export const MailboxesActionsNames = {
  ...createEntityActionNames("MAILBOXES"),
  SYNC_DELETE: "ENTITIES/MAILBOXES/SYNC_DELETE",
};

export const MailboxesActions = {
  ...createEntityActions<IMailbox>(MailboxesActionsNames),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  syncDelete: (payload: { id: string }) => createAction(MailboxesActionsNames.SYNC_DELETE, payload),
};

export enum MailboxesRequestActions {
  FETCH_COLLECTION = "FETCH_COLLECTION_MAILBOXES",
  DELETE_MAILBOXES_REQUEST = "DELETE_MAILBOXES",
  UPDATE_MAILBOXES_REQUEST = "UPDATE_MAILBOXES",
  UPDATE_DEFAULT_MAILBOX_REQUEST = "LICENSE.UPDATE_DEFAULT_MAILBOX",
  CREATE_MAILBOXES_REQUEST = "CREATE_MAILBOXES",
}

export type MailboxesAction = ActionsUnion<typeof MailboxesActions>;
